/** Which Fan panel sections are open: a per-viewer convenience in browser storage. */
import { useCallback, useState } from 'react';

const OPEN_KEY = 'om_rc_fan_sections';

function readOpen(): Record<string, boolean> {
  try {
    const raw = JSON.parse(localStorage.getItem(OPEN_KEY) || '{}') as Record<string, boolean>;
    return raw && typeof raw === 'object' ? raw : {};
  } catch {
    return {};
  }
}

/** Which sections are open (all are, until the person closes one). */
export function useSectionsOpen() {
  const [open, setOpen] = useState(readOpen);
  const toggle = useCallback(
    (id: string) =>
      setOpen((prev) => {
        const next = { ...prev, [id]: prev[id] === false };
        try {
          localStorage.setItem(OPEN_KEY, JSON.stringify(next));
        } catch {
          /* storage unavailable */
        }
        return next;
      }),
    [],
  );
  return { isOpen: (id: string) => open[id] !== false, toggle };
}

export type SectionsOpen = ReturnType<typeof useSectionsOpen>;
